<template>
    <Modal
        buttonClass="add"
        buttonText="Nieuwe aanvraag"
        ref="modalAdd"
    >
        <div>
            <Form @submitted="postForm">
                <h3>Nieuwe aanvraag</h3>
                <Select
                    label="Type"
                    name="request_type_id"
                    :required="true"
                    :options="requestTypeOptions"
                    :sortByLabel="false"
                    v-model="form.request_type_id"
                    :error="form.errors.request_type_id"
                />
                <Input
                    label="Factuur nr."
                    name="invoice_number"
                    :required="true"
                    v-model="form.invoice_number"
                    :error="form.errors.invoice_number"
                    v-if="requestTypeOptions[form.request_type_id] && requestTypeOptions[form.request_type_id].includes('Webshop')"
                />
                <Input
                    type="date"
                    label="Datum betaling"
                    name="invoice_paid_at"
                    :required="true"
                    v-model="form.invoice_paid_at"
                    :error="form.errors.invoice_paid_at"
                    v-if="requestTypeOptions[form.request_type_id] && requestTypeOptions[form.request_type_id].includes('Webshop')"
                />
                <Select
                    label="Bestek"
                    name="estimate_id"
                    :options="estimateOptions"
                    :required="true"
                    v-model="form.estimate_id"
                    :error="form.errors.estimate_id"
                    v-if="requestTypeOptions[form.request_type_id] && requestTypeOptions[form.request_type_id].includes('Bestek')"
                />
                <Button
                    text="Aanvraag aanmaken"
                    type="submit"
                    :loading="form.processing"
                    class="self-end"
                />
            </Form>
        </div>
    </Modal>
</template>

<script>
import Button from '@/Components/Button.vue'
import Modal from '@/Components/Modal.vue'
import Input from '@/Components/Input.vue'
import Form from '@/Components/Form.vue'
import Select from '@/Components/Select.vue'

import {onMounted, ref} from "vue";
import {useForm} from "@inertiajs/inertia-vue3";
import {Inertia} from "@inertiajs/inertia";
import {parseInt} from "lodash/string";

export default {
components: {
        Button,
        Modal,
        Input,
        Form,
        Select,
    },
    props: {
        requestType: {
            default: null
        },
        requestTypes: {
            required: true
        },
        estimates: {
            required: true
        },
        modalOpen: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const modalAdd = ref(null)
        let requestTypeOptions = {}
        let estimateOptions = {}

        props.requestTypes.forEach(function(requestType) {

            if (!requestType.type.includes('Webshop') || Inertia.page.props.user.roles.includes('admin'))
            {
                requestTypeOptions[requestType.id] = requestType.type
            }
        })

        props.estimates.forEach(function(estimate) {
            estimateOptions[estimate.id] = estimate.name
        })

        const form = useForm({
            request_type_id: props.requestType ?? setRequestTypeId(),
            invoice_number: null,
            invoice_paid_at: null,
            estimate_id: null,
        })

        function setRequestTypeId()
        {
            return (Inertia.page.props.user.roles.includes('admin')) ? 1 : 4
        }

        function postForm()
        {
            form.post(route('requests.add-new'))
        }

        onMounted(() => {
            if (props.modalOpen) {
                modalAdd.value.show = true
            }
        })

        return {
            modalAdd,
            requestTypeOptions,
            estimateOptions,
            form,
            postForm,
        }
    }
}
</script>
